import React from 'react';
import styles from './styles.module.scss';
import { FormattedMessage } from 'react-intl';
import { ProcessingLoader } from '../../loaders/ProcessingLoader';
import { InfoIcon } from 'assets/icons/InfoIcon';

export const InfoMessage = ({ loading, message }) => (
  <div className={styles.infoMessage}>
    {loading ? <ProcessingLoader /> : <InfoIcon />}

    <FormattedMessage id={message} />
  </div>
);
